import { LexicalEditor } from 'lexical/LexicalEditor';
import { RefObject, useRef } from 'react';

export const useEditorRef = (value?: LexicalEditor | null): RefObject<LexicalEditor> => {
  return useRef<LexicalEditor>(value ?? null);
};
